import { useState } from 'react'
import { Dialog } from 'antd-mobile'
import { searchCompany as searchCompanyAPI } from '../../api/commonService'

export interface CompanySearchResult {
  regStatus: string
  estiblishTime: string
  regCapital: string
  companyType: number
  matchType: string
  type: number
  legalPersonName: string
  regNumber: string
  creditCode: string
  name: string
  id: number
  orgNumber: string
  base: string
}

interface CompanySearchResponse {
  total: number
  items: CompanySearchResult[]
}

export function useCompanySearch() {
  const [searchResults, setSearchResults] = useState<CompanySearchResult[]>([])
  const [searching, setSearching] = useState(false)

  const searchCompany = async (companyName: string) => {
    if (searching) return
    if (companyName.length < 2) {
      Dialog.alert({
        content: '请输入公司名称关键字',
        confirmText: '确定',
      })
      return
    }

    setSearching(true)
    try {
      const response = await searchCompanyAPI(companyName)
      const data: CompanySearchResponse = JSON.parse(response)
      setSearchResults(data.items)
    } catch (error) {
      console.error('搜索出错：', error)
    } finally {
      setSearching(false)
    }
  }

  const clearResults = () => {
    setSearchResults([])
  }

  return {
    searchResults,
    searching,
    searchCompany,
    clearResults,
  }
}
